/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerSetActivationMutationRequest, TemplateActivationsControllerSetActivationMutationResponse, TemplateActivationsControllerSetActivation400, TemplateActivationsControllerSetActivation401, TemplateActivationsControllerSetActivation403, TemplateActivationsControllerSetActivation404 } from "../../models/checklistsController/TemplateActivationsControllerSetActivation";

function getTemplateActivationsControllerSetActivationUrl() {
  const res = { method: 'PUT', url: `/api/v1/checklist-template-activations` as const }  
  return res
}

/**
 * @summary Set activation status for a template at a scope (org/team)
 * {@link /api/v1/checklist-template-activations}
 */
export async function templateActivationsControllerSetActivation(data?: TemplateActivationsControllerSetActivationMutationRequest, config: Partial<RequestConfig<TemplateActivationsControllerSetActivationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateActivationsControllerSetActivationMutationResponse, ResponseErrorConfig<TemplateActivationsControllerSetActivation400 | TemplateActivationsControllerSetActivation401 | TemplateActivationsControllerSetActivation403 | TemplateActivationsControllerSetActivation404>, TemplateActivationsControllerSetActivationMutationRequest>({ method : "PUT", url : getTemplateActivationsControllerSetActivationUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}